import * as LayoutCreatorEntities from '@bimser/components/dist/BCLayoutCreator/common/entities';
import { IContainerControlProperties } from '../entities/IContainerControlProperties';
import VisualControl from './VisualControl';
import { FormItemTypes, IDictionary } from '@bimser/core';
import { IPropertyField } from '../../../entities/common';
import { JSX } from 'react';

export default class ContainerControl extends VisualControl {
	__childrenItem: LayoutCreatorEntities.NormalizedLayoutStructureItems;
	readOnly: boolean;

	constructor() {
		super();

		this.readOnly = false;

		this.prepareRenderOrderProperties = this.prepareRenderOrderProperties.bind(this);
	}

	__loadProperties(data: IContainerControlProperties) {
		super.__loadProperties(data);
		this.__proxyChanged.readOnly = data.readOnly;
	}

	__loadChildren(childrenItem: LayoutCreatorEntities.NormalizedLayoutStructureItems) {
		this.__childrenItem = childrenItem;
	}

	__getPropertyFields(): IPropertyField[] {
		const fields = super.__getPropertyFields();
		return [
			...fields,
			{
				name: 'readOnly',
				type: 'boolean',
				common: true
			}
		];
	}

	/**
	 * Container Type controls render their controls
	 * like Form control (BCLayoutCreator). We setting specific properties
	 * to calculate if there is any diffrence in order to
	 * letting render components from FormControl.tsx
	 */
	prepareRenderOrderProperties() {
		const items = this.__childrenItem?.getIn(['entities', 'items']);

		items.keySeq().forEach(key => {
			const controlType = items.getIn([key, 'type']);

			switch (controlType) {
				case FormItemTypes.EControlTypes.DataGrid: {
					const willSetProperty = this.__form[key].__columns; //setting __columns property to wath in terms of render
					if (willSetProperty) {
						this.__childrenItem = this.__childrenItem.setIn(
							['entities', 'items', key, 'properties', '__columns'],
							willSetProperty
						);
					}
					break;
				}
				default:
					break;
			}
		});

		return this.__childrenItem;
	}

	__isReadOnly() {
		if (this.__form) {
			return this.readOnly || this.__form.readOnly;
		}
	}

	__getComponentData(): IDictionary<any> {
		return {
			...super.__getComponentData(),
			readOnly: this.__isReadOnly()
		};
	}

	__render(children?: React.ReactNode): JSX.Element {
		return super.__render(children);
	}
}
